import React, { useState } from "react";

interface IToggleSwitchProps {
  isOn?: boolean;
  onToggle: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export const ToggleSwitch = (props: IToggleSwitchProps) => {
  const [checked, setChecked] = useState(props.isOn);

  const handleToggle = () => {
    if (!props.disabled) {
      setChecked(!checked);
      props.onToggle(!checked);
    }
  };

  return (
    <div className="flex justify-between items-center w-full">
      <span className="font-medium">{props.label}</span>
      <div
        className={`w-14 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors ${
          checked ? "bg-[#2fe9ff]" : "bg-gray-300"
        } ${props.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        onClick={handleToggle}
      >
        <div
          className={`w-6 h-6 bg-white rounded-full shadow-md transform transition-transform ${
            checked ? "translate-x-6" : "translate-x-0"
          }`}
        ></div>
      </div>
    </div>
  );
};
